<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';
  import { format as formatDate } from 'date-fns';
  import { addDays } from 'date-fns';

  import PushHistoryTable from './push-history-table.svelte';

  export let date = new Date();
  export let events = [];
  export let show = false;
  export let onPush = () => {};

  const toggle = () => (show = false);
</script>

{#if show}
  <Modal isOpen scrollable size="lg" fullscreen="lg" {toggle} {...$$restProps}>
    <ModalHeader class="text-center" {toggle}>
      {formatDate(date, 'EEEE, MMMM d, yyyy')}
    </ModalHeader>
    <ModalBody>
      <PushHistoryTable history={events} size="sm" startDate={date} endDate={addDays(date, 1)} {onPush} />
    </ModalBody>
    <ModalFooter>
      <Button color="primary" on:click={toggle}>
        {$format('label.CLOSE')}
      </Button>
    </ModalFooter>
  </Modal>
{/if}
